export default "__VITE_ASSET__BFybC6AO__"